import type { QueryClient } from '@tanstack/react-query';
import {
	buildTutorialDemonstracaoMedicalRecordSession,
	buildTutorialDemonstracaoMedicalRecordWithAiContent,
	TUTORIAL_DEMO_MEDICAL_RECORD_ID,
	TUTORIAL_DEMO_MEDICAL_RECORD_SESSION_ID,
	TUTORIAL_DEMO_PATIENT_ID,
} from './tutorialDemonstracaoMock';

const medicalRecordSessionQueryKey = [
	'medical-record-session',
	TUTORIAL_DEMO_MEDICAL_RECORD_ID,
	TUTORIAL_DEMO_MEDICAL_RECORD_SESSION_ID,
	'post-process',
] as const;

export type TutorialDemonstracaoReviewCache = {
	medicalRecord: MedicalRecords.MedicalRecord;
	sessionDetail: MedicalRecords.MedicalRecordSession;
	recordId: string;
	recordSessionId: string;
	isFirstSession: true;
};

export function readTutorialDemonstracaoReviewCache(
	queryClient: QueryClient,
): TutorialDemonstracaoReviewCache {
	const medicalRecord =
		queryClient.getQueryData<MedicalRecords.MedicalRecord>([
			'medical-record',
			TUTORIAL_DEMO_PATIENT_ID,
		]) ?? buildTutorialDemonstracaoMedicalRecordWithAiContent();

	const sessionDetail =
		queryClient.getQueryData<MedicalRecords.MedicalRecordSession>(
			medicalRecordSessionQueryKey,
		) ?? buildTutorialDemonstracaoMedicalRecordSession();

	return {
		medicalRecord,
		sessionDetail,
		recordId: TUTORIAL_DEMO_MEDICAL_RECORD_ID,
		recordSessionId: TUTORIAL_DEMO_MEDICAL_RECORD_SESSION_ID,
		isFirstSession: true,
	};
}
